// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"449":"b25fe18f237b64c1","460":"e52e224ffd65bb80","531":"adde4f9459b502ab","978":"4a7e1b99dbcdbd86"}[chunkId] + ".js";
};